import { ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0bb5a663"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "channel-mock-panel"
};
const _hoisted_2 = {
  class: "panel-toolbar"
};
const _hoisted_3 = {
  class: "cell-ellipsis"
};
const _hoisted_4 = {
  key: 1,
  class: "cell-ellipsis cell-code"
};
const _hoisted_5 = {
  class: "cell-ellipsis cell-code"
};
const _hoisted_6 = {
  class: "tip-json"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "删除", -1));
import { PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { getChannelMockConfigFetch, removeChannelMockConfigFetch } from '@/api/sandbox';
import { getSettingParamSourceOptions } from '@/api/paramSettingApi';
import { reportEvent, OK } from '@/common';
import { channelMockColumns } from '../data';
import ChannelMockModal from './ChannelMockModal.vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'ChannelMockPanel'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const loading = ref(false);
    const dataSource = ref([]);
    const editVisible = ref(false);
    const editItem = ref(null);
    const payChnlOptions = ref([]);
    const chnlNameMap = ref({});
    // 三方订单号字段 = orderNo 映射的 sourcePath
    const getOrderNoField = record => {
      var _record$fieldMappings, _record$fieldMappings2;
      return (_record$fieldMappings = (_record$fieldMappings2 = record.fieldMappings) === null || _record$fieldMappings2 === void 0 || (_record$fieldMappings2 = _record$fieldMappings2.find(m => m.targetField === 'orderNo')) === null || _record$fieldMappings2 === void 0 ? void 0 : _record$fieldMappings2.sourcePath) !== null && _record$fieldMappings !== void 0 ? _record$fieldMappings : '';
    };
    // 渠道展示名：优先用下拉字典里的中文名，取不到则回退渠道码
    const chnlLabel = record => {
      return chnlNameMap.value[record.payChnl] || record.payChnl;
    };
    // 支付渠道下拉/名称：复用参数配置的来源候选项接口（sourceType=CHANNEL，返回 {value,label}）
    const loadPayChnl = async () => {
      if (payChnlOptions.value.length) return;
      try {
        var _res$data;
        const res = await getSettingParamSourceOptions({
          sourceType: 'CHANNEL'
        });
        // 该接口业务成功码为 '0'（与 paramSetting 模块一致，非沙盒的 '0000'）
        if (String(res === null || res === void 0 ? void 0 : res.code) !== OK) return;
        const list = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
        const seen = new Set();
        const options = [];
        const nameMap = {};
        list.forEach(it => {
          const value = it === null || it === void 0 ? void 0 : it.value;
          const name = (it === null || it === void 0 ? void 0 : it.label) || value;
          if (value && !seen.has(value)) {
            seen.add(value);
            options.push({
              label: name === value ? value : `${name}（${value}）`,
              value,
              name
            });
            nameMap[value] = name;
          }
        });
        payChnlOptions.value = options;
        chnlNameMap.value = nameMap;
      } catch (e) {}
    };
    const getList = async () => {
      try {
        loading.value = true;
        const {
          code,
          data
        } = await getChannelMockConfigFetch({
          pageNum: 1,
          pageSize: 999
        });
        if (code === '0000') {
          var _data$list;
          dataSource.value = (_data$list = data === null || data === void 0 ? void 0 : data.list) !== null && _data$list !== void 0 ? _data$list : [];
        }
      } catch (e) {} finally {
        loading.value = false;
      }
    };
    const handleEdit = item => {
      editItem.value = item;
      editVisible.value = true;
    };
    const handleDelete = async record => {
      try {
        const {
          code,
          msg
        } = await removeChannelMockConfigFetch({
          id: record.id
        });
        if (code === '0000') {
          message.success('删除成功');
          getList();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '渠道mock配置',
              element_name: '删除'
            }
          });
        } else if (msg) {
          message.error(msg);
        }
      } catch (e) {}
    };
    onMounted(() => {
      loadPayChnl();
      getList();
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_popconfirm = _resolveComponent("a-popconfirm");
      const _component_a_table = _resolveComponent("a-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => handleEdit(null))
      }, {
        icon: _withCtx(() => [_createVNode(_unref(PlusOutlined))]),
        default: _withCtx(() => [_createTextVNode(" 新增 ")]),
        _: 1
      })]), _createVNode(_component_a_table, {
        bordered: "",
        columns: _unref(channelMockColumns),
        loading: loading.value,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'payChnl' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 0,
          placement: "topLeft",
          title: chnlLabel(record)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(chnlLabel(record)), 1)]),
          _: 2
        }, 1032, ["title"])) : column.dataIndex === 'orderNoField' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(getOrderNoField(record) || '--'), 1)) : column.dataIndex === 'mockSuccessBody' || column.dataIndex === 'mockFailBody' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 2,
          placement: "topLeft",
          overlayStyle: {
            maxWidth: '600px'
          }
        }, _createSlots({
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, _toDisplayString(record[column.dataIndex] || '--'), 1)]),
          _: 2
        }, [record[column.dataIndex] ? {
          name: "title",
          fn: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(record[column.dataIndex]), 1)]),
          key: "0"
        } : undefined]), 1024)) : column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [_createElementVNode("a", {
          class: "edit_btn",
          onClick: $event => handleEdit(record)
        }, "编辑", 8, _hoisted_7), _createVNode(_component_a_popconfirm, {
          placement: "rightBottom",
          title: "确定删除该渠道配置吗?",
          onConfirm: $event => handleDelete(record)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onConfirm"])], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["columns", "loading", "data-source"]), _createVNode(ChannelMockModal, {
        modalVisible: editVisible.value,
        "onUpdate:modalVisible": _cache[1] || (_cache[1] = $event => editVisible.value = $event),
        editItem: editItem.value,
        payChnlOptions: payChnlOptions.value,
        onRefresh: getList
      }, null, 8, ["modalVisible", "editItem", "payChnlOptions"])]);
    };
  }
});